
















































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
interface DataVo {
    type: number;
    attribute: string;
    condition: string;
    value: string;
    display: boolean;
}
@Component({
    components: {}
})
export default class FitOption extends Vue {
    @Prop()
    configSource: any[];
    @Prop()
    notice: number;
    @Prop()
    source: any;
    cindex: number;
    dataSource!: DataVo;
    keySource: any = {
        value: null,
        options: null
    };
    itemSource: Array<{
        value: any;
        options: Array<{ value: string; label: string }>;
    }> = [
        {
            value: '',
            options: []
        },
        {
            value: '',
            options: []
        }
    ];
    @Watch('notice')
    onRefresh() {
        this.createKey();
        // this.itemSource = this.createItem(this.keySource.value);
    }
    createItem(key: string) {
        for (let i = 0; i < this.configSource.length; i++) {
            const data = this.configSource[i];
            if (data.value === key) {
                return data.options;
            }
        }
        return [
            {
                value: '',
                options: []
            },
            {
                value: '',
                options: []
            }
        ];
    }
    createKey() {
        this.keySource.options = [];
        this.configSource.forEach((vo: any) => {
            const key: string = vo.value;
            if (!vo.disabled || key === this.keySource.value) {
                this.keySource.options.push({
                    value: vo.value,
                    label: vo.label
                });
            }
        });
    }
    upSearch(key: string, disabled: boolean) {
        for (let i = 0; i < this.configSource.length; i++) {
            const vo = this.configSource[i];
            const value = vo.value;
            if (value === key) {
                vo.disabled = disabled;
            }
        }
    }
    upSource() {
        this.dataSource.attribute = this.keySource.value;
        this.dataSource.condition = this.itemSource[0].value;
        this.dataSource.value = this.itemSource[1].value;
        this.dataSource.display = true;
    }
    keyChange(key: string) {
        const attribute: string = this.dataSource.attribute;
        if (attribute) {
            this.upSearch(attribute, false);
        }
        this.upSearch(key, true);
        this.itemSource = this.createItem(key);
        this.upSource();
        this.$emit('kchange', { key: this.cindex, value: this.dataSource });
    }
    onClick() {
        this.upSearch(this.keySource.value, false);
        this.$emit('delete', { key: this.cindex });
    }
    onChange() {
        this.upSource();
        this.$emit('change', { key: this.cindex, value: this.dataSource });
    }
    created() {
        const querys = this.source.querys;
        this.dataSource = {
            type: 1,
            attribute: null,
            condition: null,
            value: null,
            display: null
        };
        this.cindex = this.source.key;
        if (querys) {
            this.keySource.value = querys.attribute;
        }
        this.onRefresh();
    }
    beforeDestroy() {
        this.upSearch(this.keySource.value, false);
    }
}
